<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="推广者：" prop="member_id">
                <el-input v-model="model.member_id"></el-input>
            </el-form-item>
            <el-form-item label="推广者编号：" prop="member_code">
                <el-input v-model="model.member_code"></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <el-input v-model="model.cellphone"></el-input>
            </el-form-item>
            <el-form-item label="结算批次：" prop="settled_batch">
                <el-input v-model="model.settled_batch"></el-input>
            </el-form-item>
            <el-form-item label="结算状态：" prop="settled_state">
                <el-input v-model="model.settled_state"></el-input>
            </el-form-item>
            <el-form-item label="结算时间：" prop="settled_time">
                <el-input v-model="model.settled_time"></el-input>
            </el-form-item>
            <el-form-item label="预计结算时间：" prop="settled_time_yu">
                <el-input v-model="model.settled_time_yu"></el-input>
            </el-form-item>
            <el-form-item label="订单ID：" prop="order_id">
                <el-input v-model="model.order_id"></el-input>
            </el-form-item>
            <el-form-item label="订单编号：" prop="sn">
                <el-input v-model="model.sn"></el-input>
            </el-form-item>
            <el-form-item label="订单状态：" prop="status">
                <el-input v-model="model.status"></el-input>
            </el-form-item>
            <el-form-item label="支付时间：" prop="paytime">
                <el-input v-model="model.paytime"></el-input>
            </el-form-item>
            <el-form-item label="完成时间：" prop="completetime">
                <el-input v-model="model.completetime"></el-input>
            </el-form-item>
            <el-form-item label="收货人电话：" prop="receiver_phone">
                <el-input v-model="model.receiver_phone"></el-input>
            </el-form-item>
            <el-form-item label="商品数量：" prop="goods_count">
                <el-input v-model="model.goods_count"></el-input>
            </el-form-item>
            <el-form-item label="支付金额：" prop="pay_price">
                <el-input v-model="model.pay_price"></el-input>
            </el-form-item>
            <el-form-item label="佣金：" prop="commission">
                <el-input v-model="model.commission"></el-input>
            </el-form-item>
            <el-form-item label="团购订单：" prop="is_tuan">
                <el-input v-model="model.is_tuan"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'promotionOrderEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                member_code: '',
                name: '',
                cellphone: '',
                settled_batch: '',
                settled_state: '',
                settled_time: '',
                settled_time_yu: '',
                order_id: '',
                sn: '',
                status: '',
                paytime: '',
                completetime: '',
                receiver_phone: '',
                goods_count: '',
                pay_price: '',
                commission: '',
                is_tuan: '',
            },
            getObj:{
                url:'/api/admin/promotionorder/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/promotionorder/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>